function describePriceAges(price) {
  if (price.ageAware) {
    const franjas = price.agePrices.sort((a, b) => b - a)
    const options = franjas.map((franja, i) => {
      const age = franja.age
      const value = franja.price
      
      return { 
        key: age, 
        age,
        title: `到 ${age} 岁`, 
        ages: (
          i == price.agePrices.length - 1 
            ? `0 至 ${age} 岁 (包含)` 
            : `${franjas[i + 1].age + 1} 至 ${age} 岁 (包含)`
        ), 
        price: value 
      }
    })

    return [
      { 
        key: "g", 
        age: Infinity, 
        title: "成人票", 
        ages: `${franjas[0].age + 1} 岁以上`, 
        price: price.general 
      },
      ...options
    ] 
  }
  else {
    return [
      { key: "g", title: "成人票", ages: `适用于任何年龄`, price: price.general }
    ] 
  }
} 

export default describePriceAges


// WEBPACK FOOTER //
// ./src/app/catalogo/reservation/describePriceAges.js